var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"slide-container"},[_c('div',{staticClass:"container"},[_vm._m(0),(_vm.$store.state.menus.length>0)?_c('menu-list'):_vm._e()],1)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"logo-container"},[_c('div',{staticClass:"logo"}),_c('div',{staticClass:"logo-txt"},[_vm._v("公会后台系统")])])
}]

export { render, staticRenderFns }